import { ContainerModule } from 'inversify';
import { AppDependencyTypes } from '@shared/common/app/app.dependency-types';
import { AppPresenter } from '@shared/common/app/domain/presenter/app.presenter';

export const appContainerModule = new ContainerModule(({ bind }) => {
  bind<AppPresenter>(AppDependencyTypes.AppPresenter).to(AppPresenter).inSingletonScope();
});
